import React from "react";
import "./style.scss";
import placeholder from "../../../assets/images/placeholder-dark.svg";
import Button from "../../elements/button/Button";
import { Container } from "react-bootstrap";

const ColItem = ({ title, placeholder, options, icon, callToAction }) => {
  return (
    <div className="col-item">
      <div className="top-section">
        <img src={placeholder} alt={placeholder} />
        <h3 className="title-header">{title}</h3>
      </div>
      <div className={`options ${icon}`}>
        {options &&
          options.map((option, i) => {
            return (
              <div key={i} className="option-item">
                <img alt="icon" />
                <p>{option}</p>
              </div>
            );
          })}
      </div>
      {callToAction && (
        <div className="callToAction">
          <Button>Get Your Free Offer →</Button>
        </div>
      )}
    </div>
  );
};

const StackUp = (props) => {
  return (
    <div className="how_we_stack_up">
      <Container>
        <h1 className="title">See how we stack up</h1>
        <p className="subtitle">
          {`We’re a team of founders and builders who have grown our own \ne-commerce
        businesses and are committed to looking after yours.`}
        </p>
        <div className="d-flex flex-row flex-wrap justify-content-around">
          <ColItem
            title="Traditional Brokers"
            placeholder={placeholder}
            options={[
              "Takes 3–6 months if you can find a buyer, \nwith uncertainty when it will close.",
              "Brokers take 10% of your business.",
              "You’re locked into the business for long \nearnouts.",
            ]}
            icon="x"
          />
          <hr className="separator" />
          <ColItem
            title="OpenStore"
            placeholder={placeholder}
            options={[
              "Get an offer within 24 hours and close \nquickly after accepting.",
              "Get paid and cut out the middleman.",
              "You’re free to pursue what’s next.",
            ]}
            icon="check"
            callToAction
          />
        </div>
      </Container>
    </div>
  );
};

export default StackUp;
